import React, { lazy, Suspense } from 'react';
import { Loader } from '../../components/UI/Loader';

const SiteVisitView = lazy(() =>
  import('../../modules/SiteVisit').then(module => ({ default: module.SiteVisitView }))
);

const PageSiteVisitView: React.FC = () => {
  return (
    <Suspense fallback={<Loader />}>
      <SiteVisitView />
    </Suspense>
  );
};

export default PageSiteVisitView;
